/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import htmlParser from "html-react-parser";
import "../Body/Body.css";

export default function Body({ bannerData, links }) {
  
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const imgCDNURL = process.env.REACT_APP_CDN_LINK + "mastermind/may2024/";
  const desktopBackgroundImageURL = imgCDNURL + "bannerbg-desktop.webp";
  const mobileBackgroundImageURL = imgCDNURL + "bannerbg-mobile.webp";

  useEffect(() => {
    const img = new Image();
    img.src = desktopBackgroundImageURL;

    img.onload = () => {
      console.log('Background image is preloaded');
      setIsImageLoaded(true);
    };

    return () => {
      // Cleanup to prevent memory leaks
      img.onload = null;
    };
  }, [desktopBackgroundImageURL]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Listen for window resize events
    window.addEventListener("resize", handleResize);

    return () => {
      // Cleanup event listener
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const bannerStyle = {
    backgroundRepeat: "no-repeat",
    paddingBottom: windowWidth <= 992 ? "0rem" : "1rem",
    marginBottom: windowWidth <= 992 ? "-2rem" : "0rem",
    backgroundImage: `url(${windowWidth <= 992 ? mobileBackgroundImageURL : desktopBackgroundImageURL})`,
    backgroundSize: windowWidth <= 992 ? "100% 100%" : "100% 100%",
    ariaLabel: "Banner Background", // Replace with a meaningful description
  };

  return (
    <>
      <div className="banner" style={isImageLoaded ? bannerStyle : {}} aria-label={bannerStyle.ariaLabel}>
        <Container>
          <Row>
            <Col lg={12} md={12} sm={12} xs={12}>

              <div className="bannertextdesktop">
                {/* <div>
                  <a
                    href={"https://www.swmc.com/"}
                    target="_blank"
                    rel="noopener noreferrer"

                  >
                    <picture>
                    <img
                      src={process.env.REACT_APP_CDN_LINK + "swmc-images/sunwest-trust-white-logo.png"}
                      className="sunwestlogo"
                      title="SunWest-Logo"
                      alt="SunWest-Logo"
                      width="100%"
                      
                    ></img>
                    </picture>
                  </a>
                </div> */}
                <p className="mastermind">{htmlParser(bannerData.mastermindbannerheading)}</p>
              </div>
              <div className="bannertextsub">
                <p>{htmlParser(bannerData.mastermindsubheading1)}</p>
              </div>
              <div className="bannertextsubpara">
                <p>{htmlParser(bannerData.mastermindsubheading2)}</p>


              </div>

              </Col>
          </Row>
          <div className="desk-explore">
            <div className="exploreandeditoin">
              <div lg={12} md={12} sm={12} xs={12}>
                <div className="editionbox">
                  <div className="edition">
                    <p className="textedition">
                      {htmlParser(bannerData.monthedition)}
                    </p>                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
        <div className="mobile-explore">
        <div className="exploreandeditoinmobile d-flex">
          <Col lg={12} md={12} sm={12} xs={12}>
            <div className="editionbox">
              <div className="edition">
                <p className="textedition">
                  {htmlParser(bannerData.montheditionmobile)}
                </p>
              </div>
            </div>
          </Col>
        </div>
        </div>
      </div>

    </>
  );
}
